var _path, _path2, _line, _rect, _circle, _circle2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebposIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.31,
    height: 42.34,
    viewBox: "0 0 31.31 42.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59,41.54H25.71a2.45,2.45,0,0,0,2.45-2.45V24.44l2.12-8.09a6.22,6.22,0,0,0-1-5.42c-3.21-4.35-24-4.35-27.19,0a6.22,6.22,0,0,0-1,5.42l2.13,8.09V39.09A2.45,2.45,0,0,0,5.59,41.54Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64,8.22V1.74a1,1,0,0,1,1-.94h16a1,1,0,0,1,1,.94V8.22",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    fillRule: "evenodd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.52,
    y1: 0.8,
    x2: 17.52,
    y2: 7.51,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.78,
    y: 14.24,
    width: 15.75,
    height: 7.24,
    rx: 1.49,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.04,
    cy: 28.69,
    r: 1.93,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.65,
    cy: 28.69,
    r: 1.93,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.27,26.77a1.93,1.93,0,1,0,1.93,1.92A1.93,1.93,0,0,0,21.27,26.77Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10,32.18A1.93,1.93,0,1,0,12,34.1,1.93,1.93,0,0,0,10,32.18Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65,32.18a1.93,1.93,0,1,0,1.93,1.92A1.92,1.92,0,0,0,15.65,32.18Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.27,32.18A1.93,1.93,0,1,0,23.2,34.1,1.93,1.93,0,0,0,21.27,32.18Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebposIcon);
export default __webpack_public_path__ + "static/media/webpos-icon.26181f65716e1d45de15a9f5faa477f5.svg";
export { ForwardRef as ReactComponent };